module.exports = __webpack_public_path__ + "media/a1.2874685e.mp3";